// import React from "react";
import * as React from "react";

import TabContent from "../tabsContent";
// import TabContent from "./TabContent";

const Tabs: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState("Monthly");
  const tap = [
    { id: "Monthly", name: "Monthly" },
    { id: "Yearly", name: "Yearly" },
    { id: "LifeTime", name: "LifeTime" },
  ];

  return (
    <div className="mb-20">
      <h1 className="text-6xl font-bold text-center mt-16 mb-16 ">
        Most Affordable Package
      </h1>
      <div className="flex justify-center   ">
        <div className="bg-red-100 py-3 px-10 rounded-2xl mb-6  space-x-4  ">
          {tap.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={`px-4 py-2 rounded-2xl transition-all transform ${
                activeTab === item.id
                  ? "bg-primary text-white scale-105"
                  : "text-gray-700 hover:bg-primary hover:text-white hover:scale-105"
              }`}
            >
              {item.name}
            </button>
          ))}
        </div>
      </div>
      <div className="tabs-content mt-6">
        <TabContent activeTab={activeTab} />
      </div>
    </div>
  );
};

export default Tabs;
